import { render, staticRenderFns } from "./PersonIcon.vue?vue&type=template&id=590212c4&scoped=true&"
import script from "./PersonIcon.vue?vue&type=script&lang=js&"
export * from "./PersonIcon.vue?vue&type=script&lang=js&"
import style0 from "./PersonIcon.vue?vue&type=style&index=0&id=590212c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590212c4",
  null
  
)

export default component.exports